import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CreditCashback icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CreditCashback } from '@sravni/design-system-icons'
 *
 * <CreditCashback />
 * ```
 */
var CreditCashback = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CreditCashback", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.903 17.5a4.167 4.167 0 1 1 0-8.334 4.167 4.167 0 0 1 0 8.334ZM13.443 14.792l2.917-2.917M2.402 5.708h15.834", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M18.236 10.833V4.167c0-.921-.746-1.667-1.667-1.667h-12.5c-.92 0-1.667.746-1.667 1.667v7.5c0 .92.746 1.666 1.667 1.666h6.667", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("circle", { cx: "13.444", cy: "11.875", r: ".792", fill: "currentColor" }),
    React.createElement("circle", { cx: "16.36", cy: "14.792", fill: "currentColor", r: ".792" }))); });

export { CreditCashback };
//# sourceMappingURL=CreditCashback.js.map
